import { z } from '@harvestiq/zod';

export const getSettingsResponseSchema = z
  .object({
    data: z.object({
      appSettings: z.record(z.any()),
      version: z.string(),
      sha: z.string(),
      roles: z.array(z.string()),
      isRootOrg: z.boolean(),
    }),
  })
  .or(
    z.object({
      errors: z.array(z.string()),
    })
  );

export type GetSettingsResponse = z.infer<typeof getSettingsResponseSchema>;
